import { useRef } from "react";
import { InstagramLogo } from "@phosphor-icons/react";
import { gsap, useGSAP, MOTION_OK } from "../gsap";
import { CtaButton } from "./CtaButton";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../content";
import { Logo } from "./Logo";

export function Footer() {
  const root = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        // The closing question rises line by line to hand over to the button.
        gsap.from(".cta-line", {
          yPercent: 115,
          duration: 1.3,
          stagger: 0.12,
          ease: "expo.out",
          scrollTrigger: { trigger: root.current, start: "top 65%" },
        });
      });
    },
    { scope: root },
  );

  return (
    <footer ref={root} className="px-4 pt-20 md:px-8 md:pt-48">
      <div className="flex flex-col items-start gap-12 md:gap-16">
        <h2 className="font-display text-[11vw] font-extrabold uppercase leading-[0.9] tracking-[-0.045em] md:text-[6.8vw]">
          <span className="block overflow-hidden pt-[0.06em]">
            <span className="cta-line block">Got an idea?</span>
          </span>
          <span className="block overflow-hidden pt-[0.06em]">
            <span className="cta-line block text-outline">Send it over.</span>
          </span>
        </h2>
        <CtaButton size="lg" magnetic />
      </div>

      <div className="mt-20 flex flex-col gap-1 border-t border-white/10 py-6 text-sm text-smoke md:mt-32 md:flex-row md:items-center md:justify-between md:gap-4 md:py-8">
        <p className="flex items-center gap-4">
          <Logo className="h-16 w-16" />
          &copy; {new Date().getFullYear()} Miss Stabbypants
        </p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center gap-2 transition-colors duration-500 ease-heavy hover:text-bone"
        >
          <InstagramLogo weight="light" size={18} />
          {INSTAGRAM_HANDLE}
        </a>
        <a href="#top" className="inline-flex min-h-11 items-center transition-colors duration-500 ease-heavy hover:text-bone">
          Back to top
        </a>
      </div>
    </footer>
  );
}
